var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 457.42 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #231f20;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: url(#New_Gradient_Swatch_4-2);\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_7-2);\n      }\n\n      .cls-5 {\n        fill: url(#New_Gradient_Swatch_7);\n      }\n\n      .cls-6 {\n        fill: url(#New_Gradient_Swatch_4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    "data-name": "New Gradient Swatch 4",
    x1: 121.87,
    y1: 196.93,
    x2: 248.45,
    y2: 196.93,
    gradientTransform: "translate(302.58 -69.16) rotate(76.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f3fbfd",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#bce8f5",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#93daef",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7ad2ec",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#71cfeb",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#26a9e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    "data-name": "New Gradient Swatch 4",
    x1: 219.1,
    y1: 336.84,
    x2: 219.1,
    y2: 87.11,
    gradientTransform: "translate(258.95 -119.33) rotate(59.62)",
    href: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7",
    "data-name": "New Gradient Swatch 7",
    x1: 300.2,
    y1: 290.33,
    x2: 300.2,
    y2: 24.58,
    gradientTransform: "translate(78.04 -98.58) rotate(21.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fbfdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#ddeaad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#cadf7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#c3db6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8bc53f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_7-2",
    "data-name": "New Gradient Swatch 7",
    x1: 268.56,
    y1: 293.11,
    x2: 268.56,
    y2: 60.65,
    gradientTransform: "translate(165.94 -127.88) rotate(38.02)",
    href: "#New_Gradient_Swatch_7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.96,301.61c-.24-.48-.57-.65-.97-.65s-.73.16-.97.65l-23.67,52.83c-.08.16-.16.32-.16.49,0,.65.48,1.13,1.05,1.13.48,0,.81-.24.97-.57l7.84-17.77h29.81l7.92,17.77c.16.32.49.57.97.57.57,0,1.05-.48,1.05-1.13,0-.16-.08-.32-.16-.49l-23.67-52.83h0ZM43.99,303.95l14.06,31.83h-28.11l14.06-31.83h0ZM77.53,321.45v33.57c0,.55.48,1.03,1.03,1.03s1.03-.47,1.03-1.03v-19.08c0-7.76,6.81-13.78,14.33-13.78.55,0,.79-.4.79-.87s-.32-.87-.79-.87c-6.18,0-12.27,3.72-14.33,8.87v-7.84c0-.55-.48-1.03-1.03-1.03s-1.03.48-1.03,1.03h0ZM130.81,329.21c0-.32-.16-.63-.32-.87-3.17-4.91-8.71-8.23-15.2-8.23-10.61,0-18.13,8.08-18.13,18.13s7.52,18.13,18.13,18.13c6.49,0,12.03-3.33,15.2-8.23.16-.24.32-.55.32-.87,0-.47-.4-.87-.95-.87-.48,0-.71.24-.95.55-3.09,4.75-7.84,7.52-13.62,7.52-9.42,0-16.07-7.36-16.07-16.23s6.65-16.23,16.07-16.23c5.78,0,10.53,2.77,13.62,7.52.24.32.48.55.95.55.55,0,.95-.4.95-.87h0ZM207.87,312.51c-3.15-6.71-10.18-11.88-19.95-11.88-17.61,0-31.83,15.35-31.83,32.88,0,12.28,8,22.86,22.05,22.86,10.26,0,18.99-5.17,24.16-11.88.16-.24.32-.4.32-.81,0-.48-.48-.81-.97-.81-.32,0-.65.16-.89.49-6.06,7.19-13.65,11.07-22.22,11.07-13.41,0-20.36-9.77-20.36-21.08,0-15.67,12.76-30.78,29.49-30.78,8.48,0,14.78,3.55,18.58,10.91.16.4.48.57.81.57.48,0,.97-.32.97-.97,0-.16,0-.24-.16-.56h0ZM248.32,334.99c0-8.79-6.33-14.88-15.44-14.88-12.03,0-21.46,9.18-21.46,21.46,0,8.23,5.94,14.8,15.2,14.8,12.67,0,21.69-10.21,21.69-21.38h0ZM227.02,354.46c-8.87,0-13.54-5.54-13.54-13.14,0-11.01,8.55-19.32,19.24-19.32,8.16,0,13.54,5.23,13.54,13.22,0,10.05-8.39,19.24-19.24,19.24h0ZM283.93,356.03c.54,0,1.09-.46,1.19-1l3.62-18.61c1.66-8.53-3.64-15.3-12.48-15.3s-16.77,6.77-18.43,15.3l-3.62,18.61c-.1.54.27,1,.81,1s1.09-.46,1.19-1l3.63-18.69c1.45-7.46,8.2-13.3,16.04-13.3s12.32,5.85,10.87,13.3l-3.63,18.69c-.1.54.27,1,.81,1h0ZM324.84,356.03c.54,0,1.09-.46,1.19-1l3.62-18.61c1.66-8.53-3.64-15.3-12.48-15.3s-16.77,6.77-18.43,15.3l-3.62,18.61c-.1.54.27,1,.81,1s1.09-.46,1.19-1l3.63-18.69c1.45-7.46,8.2-13.3,16.04-13.3s12.32,5.85,10.87,13.3l-3.63,18.69c-.1.54.27,1,.81,1h0ZM372.38,337.6c.16-1.03.24-2.06.24-3.09,0-8.08-5.86-14.41-14.41-14.41-11.64,0-20.9,9.98-20.9,21.22,0,8.23,5.62,15.04,15.2,15.04,7.21,0,12.75-3.4,16.78-8.31.63-.71.16-1.58-.63-1.58-.4,0-.63.16-.87.48-3.88,4.83-9.1,7.68-14.96,7.68-8.63,0-13.46-5.86-13.46-13.22,0-.95.08-1.9.24-2.85h31.51c.71,0,1.19-.32,1.27-.95h0ZM370.55,336.73h-30.56c1.66-8,9.5-14.96,17.97-14.96,7.76,0,12.75,5.62,12.75,12.83,0,.71-.08,1.43-.16,2.14h0ZM414.81,328.41c-2.14-4.91-7.36-8.31-13.93-8.31-12.35,0-21.38,9.11-21.38,21.38,0,8.55,6.02,14.88,15.36,14.88,7.6,0,12.9-3.48,16.79-8.31.24-.32.32-.55.32-.79,0-.47-.4-.87-.95-.87-.32,0-.63.16-.95.55-4.12,5.07-8.63,7.52-14.96,7.52-9.03,0-13.54-5.78-13.54-13.14,0-11.08,8.31-19.32,19.24-19.32,5.78,0,10.37,2.77,12.27,7.36.16.4.47.63.95.63s.95-.32.95-.95c0-.24-.08-.4-.16-.63h0ZM442.52,321.84c0-.47-.4-.79-1.03-.79h-9.5l2.06-11.8c.08-.63-.24-1.03-.87-1.03-.71,0-1.03.32-1.19,1.03l-2.06,11.8h-8.23c-.55,0-1.03.32-1.03.95,0,.39.32.79.95.79h8l-5.7,32.22c-.08.55.24,1.03.87,1.03.71,0,1.11-.4,1.19-1.03l5.7-32.22h9.74c.55,0,1.11-.32,1.11-.95h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 155.22,
    cy: 157.46,
    rx: 141.02,
    ry: 55.29,
    transform: "translate(-47.98 244.61) rotate(-68.63)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 186.86,
    cy: 176.88,
    rx: 141.02,
    ry: 55.29,
    transform: "translate(-67.58 215.14) rotate(-51.98)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 300.2,
    cy: 157.46,
    rx: 55.29,
    ry: 141.02,
    transform: "translate(-36.74 120.24) rotate(-21.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 268.56,
    cy: 176.88,
    rx: 55.29,
    ry: 141.02,
    transform: "translate(-51.96 202.95) rotate(-38.02)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcLogoWithText);
export default __webpack_public_path__ + "static/media/arc-logo-with-text.f0b49e5ec318703b85371f662d119487.svg";
export { ForwardRef as ReactComponent };